import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUserRole } from '../../hooks/useUserRole';
import { Box, CircularProgress } from '@mui/material';

const QSRouteGuard: React.FC = () => {
  const { role, isLoading, error } = useUserRole();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || (role !== 'qs' && role !== 'super_qs' && role !== 'admin')) {
    return <Navigate to="/dienstleister" replace />;
  }

  return <Outlet />;
};

export default QSRouteGuard; 